/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { useLocation } from 'react-router-dom';
import { BASIC_DEFAULT_PROPS, BASIC_PROP_TYPES } from './util';
import BasicBreadcrumb from './basic-breadcrumb';
function BreadcrumbWithRouter(props) {
    const { pathname } = useLocation();
    return React.createElement(BasicBreadcrumb, { ...props, currentLocation: pathname });
}
BreadcrumbWithRouter.propTypes = BASIC_PROP_TYPES;
BreadcrumbWithRouter.defaultProps = BASIC_DEFAULT_PROPS;
export default BreadcrumbWithRouter;
